export function setBaseConfigs(env) {
  const baseUrl = env.build === 'production' ? 'https://api.britesignal.com/' : 'https://tv-ad-server-api-testing.herokuapp.com/' 
  console.log("Base URL for the API is", baseUrl)
  window.configs = {
    baseUrl,
    // baseUrl: 'http://localhost:3000/'
  }
}
